import { isBlockEditor } from 'utils/editor-context';

/*
 * Variant is-style-scroll-zoom: writes scroll progress (0 → 1) of each such section into
 * the --p custom property; style.scss turns it into the shrinking frame and fading content.
 * Front end only: in the editor the section stays static, like with reduced motion.
 */
const sections = [];
let ticking = false;

const headerOffset = () => {
    const header = document.querySelector('.header');
    if (!header) return 0;
    const position = getComputedStyle(header).position;
    return position === 'fixed' || position === 'sticky' ? header.offsetHeight : 0;
};

const update = () => {
    ticking = false;
    sections.forEach(({ section, sticky }) => {
        const range = section.offsetHeight - sticky.offsetHeight;
        const offset = parseFloat(section.style.getPropertyValue('--bn-header-offset')) || 0;
        const scrolled = offset - section.getBoundingClientRect().top;
        const progress = range > 0 ? Math.min(1, Math.max(0, scrolled / range)) : 0;
        section.style.setProperty('--p', progress.toFixed(4));
    });
};

const requestUpdate = () => {
    if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
    }
};

const measure = () => {
    const offset = headerOffset();
    sections.forEach(({ section }) => section.style.setProperty('--bn-header-offset', `${offset}px`));
    requestUpdate();
};

const initScrollZoom = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.bn-section.is-style-scroll-zoom').forEach((section) => {
        const sticky = section.querySelector(':scope > .bn-section__sticky');
        if (!sticky) return;
        section.classList.add('--zoom-ready');
        sections.push({ section, sticky });
    });

    if (!sections.length) return;

    measure();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', measure);
};

document.addEventListener('DOMContentLoaded', function () {
    if (!isBlockEditor()) {
        initScrollZoom();
    }
});
